export function validateBirthday(event)
{
var Month = document.getElementById("MonthDrop").value;
var Day = document.getElementById("daytext").value;
var Year = document.getElementById("yeartext").value;
var currentYear = new Date().getFullYear();
var days31 = ["01","03","05","07","08","10","12"].includes(Month);
var days30 = ["04","06","09","11"].includes(Month);
if(Month!="00")
{
    if(Day =="")
    {
    alert("Please Enter Day");
    event.preventDefault();
    return false;
    }
}
if(Day !=""){
    if(Month=="00")
{
    alert("Please select Month");
    event.preventDefault();
    return false;
}  
}
if(Year !=""){
    if(Month=="00")
{
    alert("Please select Month");
    event.preventDefault();
    return false;
}
if(Day =="")
{
alert("Please Enter Day");
event.preventDefault();
return false;
}
}
if(days31==true)
{
    if(Day > 31 || Day <= 0){
    alert("Please Enter Valid Day");
    event.preventDefault();
    return false;
    }
}
if(days30 == true)
{
    if(Day > 30 || Day <=0){
    alert("Please Enter Valid Day");
    event.preventDefault();
    return false;
    }
}
if(Month == "02")
{
    if(Year != "")
    {
    if ((!(Year % 4) && Year % 100) || !(Year % 400))
    {
        if(Day > 29|| Day <=0)
        {
        alert("Please Enter Valid Day");
        event.preventDefault();
        return false;
        }
    }
    else if(Day > 28 || Day <=0)
    {
        alert("Please Enter Valid Day");
        event.preventDefault();
        return false;
    }
    }
    else
    {
    if(Day > 29 || Day <=0)
    {
        alert("Please Enter Valid Day");
        event.preventDefault();
        return false;
    }
    }
}
if(Year > currentYear)
{
    alert("Are you sure birthdate is in the future");
    event.preventDefault();
    return false;
}
return true;
}

export function fileValidation(event) {
    var fileInput =  
        document.getElementsByName('pictureRef'); 
    var filePath = fileInput[0].value;
    var file = fileInput[0].files[0];
    console.log(file);
    // Allowing file type
    var allowedExtensions =  
            /(\.jpg|\.jpeg|\.png|\.jfif)$/i;
      
    if (!allowedExtensions.exec(filePath) && filePath != "") {
        document.getElementById("pictureRef").value = "";
        alert('Invalid file type, Please upload image in jpg, jfif or png format');
        fileInput.value = '';
        document.getElementById('preview').src ="";
        event.preventDefault();
        return false;
    }else if(file.size > 10485760){
        document.getElementById("pictureRef").value = "";
        alert('File should be less than 10MB');
        event.preventDefault();
        return false;
    }
    else{
        return true;
    }
   }

export default validateBirthday;